<template>

  <div class="page">

    <div class="top"></div>
    
  <!-- block开始 -->
  <div class="content-block">

    <div class="main">

      <div class="bg">

        <div class="sign">

          <vue-esign
            ref="esign"
            :width="458"
            :height="333"
            :isCrop="isCrop"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
            :bgColor.sync="bgColor"
          />
          <!-- <button @click="handleReset">清空画板</button> 
          <button @click="handleGenerate">生成图片</button> -->
        </div>

        <div class="reset" @click="handleReset"></div>

        <div class="input">
          <van-cell-group>
            <van-field v-model="name" maxlength="6" border="" label="" placeholder="你的名字" input-align="center"/>
          </van-cell-group>
        </div>

      </div>

      <div class="btn-create">
        <!-- <van-button round block @click="submit" color="#0bba9b">提交</van-button> -->
        <div class="btn" @click="submit"></div>
      </div>

    </div>

  </div>
  <!-- block结束 -->


  </div>

</template>

<script>
import { setStore } from "@/util/store";
import { Toast } from 'vant';
export default {
  props: ['selectId', 'resultImg'],
  data() {
    return {
      name: '',
      lineWidth: 10,
      lineColor: '#000000',
      bgColor: '',
      nameImg: '',
      isCrop: false,

      msg: "你好，这里是测试的内容",
      font: "微软雅黑",
      fontSize: '28',
      fontCor: "#000000",
      imgSrc: ''
    };
  },
  components: {
    // Toast
  },
  mounted() {
    console.log(this.selectId)
  },
  methods: {
    handleReset () {
      this.$refs.esign.reset()
    },
    handleGenerate () {
      this.$refs.esign.generate().then(res => {
        console.log(res)
        this.nameImg = res
      }).catch(err => {
        alert(err)
      })
    },
    // 提交到下一步
    submit () {
      this.$refs.esign.generate().then(res => {
        console.log(res)
        this.nameImg = res

        setStore({name: 'nameImg', content: this.nameImg});
        this.$emit("next", this.nameImg);
      }).catch(err => {
        console.log(err)
        if ( !this.name ) {
          Toast.fail('请写下 OR 输入你的名字')
          return;
        } else {
          this.nameImg = this.drawLogo(this.name, this.font);

          setStore({name: 'nameImg', content: this.nameImg});
          this.$emit("next", this.nameImg);
        }
      })

      // console.log(this.name)
      // if ( !this.name && !this.nameImg ) {
      //   Toast.fail('请写下 OR 输入你的名字');
      //   return;
      // }
      // this.$emit("next", this.nameImg);
    },
    // creatImg () {
    //   this.drawLogo(this.msg,this.font);
    // },
    drawLogo (text, font) {
      // 创建画布
      let canvas = document.createElement('canvas');
      // 绘制文字环境
      let context = canvas.getContext('2d');
      // context.globalAlpha = 0;
      // 设置字体
      context.font = font;
      // 获取字体宽度
      // let width = context.measureText(text).width;
      // // 如果宽度不够 240
      // if (width < 240) {
      //   width = 450;
      // } else {
      //   width = width + 30;
      // }
      // 画布宽度
      canvas.width = 180;
      // 画布高度
      canvas.height = 60;
      // 填充白色
      // context.fillStyle = '#ffffff';
      context.fillStyle = 'rgba(255, 255, 255, 0)';
      // 绘制文字之前填充白色
      context.fillRect(0, 0, canvas.width, canvas.height);
      // 设置字体
      context.font = this.fontSize+"px "+font;
      // 设置水平对齐方式
      context.textAlign = 'center';
      // 设置垂直对齐方式
      context.textBaseline = 'middle';
      // 设置字体颜色
      context.fillStyle = this.fontCor;
      // context.fillStyle = '#000000';
      // 绘制文字(参数：要写的字，x坐标，y坐标)
      context.fillText(text, canvas.width / 2, canvas.height / 2);
      // 生成图片信息
      let dataUrl = canvas.toDataURL('image/png');
      // this.imgSrc = dataUrl;
      // this.nameImg = dataUrl;
      // console.log(dataUrl)

      return dataUrl;
    }
  },
};
</script>

<style scoped lang="less">
/deep/.van-cell-group {
  background-color: transparent !important;
}
.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
  border: 0 none;
}
/deep/.van-cell {
  color: #ffda02 !important;
  height: 60px !important;
  line-height: 60px !important;
  padding: 0;
  background-color: transparent !important;
  border: 0 none;
}
/deep/.van-field__control::placeholder {
  font-family: 'zpix';
  color: #ffda02 !important;
}
/deep/.van-field__control {
  color: #ffda02 !important;
  line-height: 60px !important;
  background-color: transparent !important;
  font-size: 40px;
  border: 0 none;
}
.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
  .content-block {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1200px;
    top: 50%;
    margin-top: -600px;
  }
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../images/title.png") no-repeat;
  background-size: 100%;
}
.main {
  z-index: 3;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  bottom: 3%;
  margin: 0 auto;
  box-sizing: border-box;
  .bg {
    width: 660px;
    height: 664px;
    background: url("../images/bg/bg-sign.png") no-repeat;
    background-size: 100%;
    margin: 0 auto 150px;
    .sign {
      // border: 1px solid red;
      position: absolute;
      top: 30px;
      left: 150px;
      width: 458px;
      height: 333px;
      overflow: hidden;
    }
    .reset {
      position: absolute;
      z-index: 4;
      top: 360px;
      right: 73px;
      width: 71px;
      height: 67px;
      background: url("../images/btn-reset.png") no-repeat;
      background-size: 100%;
    }
    .input {
      // border: 1px solid red;
      background-color: transparent;
      position: absolute;
      top: 555px;
      left: 130px;
      width: 500px;
      height: 60px;
      // overflow: hidden;
    }
  }
  .btn-create {
    width: 648px;
    height: 91px;
    background: url("../images/btn-bg.png") no-repeat center center;
    background-size: 648px 91px;
    text-align: center;
    margin: 0 auto;
    .btn {
      width: 299px;
      height: 91px;
      margin: 0 auto;
      background: url("../images/btn-create.png") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
